module.exports = __webpack_public_path__ + "static/media/basic.1359710c.svg";